import { useState, useEffect } from "react";
import { Layer, Source } from "react-map-gl";
import { getTileBandMaxValues } from "../api/scenes";

const scale = window.devicePixelRatio;

type Props = {
  id: string;
  brightness?: number;
  contrast?: number;
};

function MapScenePreview({ id, brightness = 1.25, contrast = 4 }: Props) {
  const [maxValues, setMaxValues] = useState<{ maxB2: number; maxB3: number; maxB5: number }>({
    maxB2: 250,
    maxB3: 250,
    maxB5: 250,
  });

  useEffect(() => {
    const fetchMaxValues = async () => {
      getTileBandMaxValues(id).then(setMaxValues);  
    };

    fetchMaxValues();
  }, [id]);

  return (
    <Source
      id={`scene-preview-source-${id}`}
      type="raster"
      tiles={[
        `${process.env.REACT_APP_API_BASE}/tiler/tiles/WebMercatorQuad/{z}/{x}/{y}@${Math.round(scale)}x.webp?url=${id}/pansharpened_cog.tif&coord_crs=epsg:4326&dst_crs=epsg:3857&bidx=5&rescale=0,${maxValues.maxB2}&bidx=3&rescale=0,${maxValues.maxB3}&bidx=2&rescale=0,${maxValues.maxB2}&color_formula=Gamma RGB ${brightness} Saturation 1.1 Sigmoidal RGB ${contrast} 0.5
      `,
      ]}
      tileSize={256}
    >
      <Layer id={`scene-preview-layer-${id}`} type="raster" />
    </Source>
  );
}

export default MapScenePreview;
